import { addPermissionsToRoute } from '@qsrsoft/myq-core';
import { multiClientMenuFilters } from '../mtEnterprises';
const routes = {
  name: 'Product',
  icon: 'mdi-cube-outline',
  path: '/reports/product/',
  ...addPermissionsToRoute(['mtProduct']),
  menuFilters: multiClientMenuFilters,
  children: [
    {
      path: '/reports/product/productMixDrillDown',
      name: 'Product Mix',
      meta: {
        id: 'reports-mtPmixDrillDown',
      },
      component: () => import('./ProductMix.vue'),
    },
    {
      path: '/reports/product/productMixTrend',
      name: 'Product Mix Trend',
      meta: {
        id: 'reports-mtProductMixTrend',
      },
      component: () => import('./ProductMixTrend.vue'),
    },
    {
      path: '/reports/product/productMixDrillDownLegacy',
      name: 'Product Mix (Legacy)',
      meta: {
        id: 'reports-mtPmixLegacy',
      },
      component: () => import('../../standard/product/ProductMix.vue'),
    },
  ],
};

export default routes;
